import {
  ParcelSchema,
  type IParcel,
} from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod";
import { null as zNull } from "zod";

export const updateParcel = {
  name: "updateParcel" as const,
  input: z.object({
    originalName: z.string(),
    parcel: ParcelSchema as IParcel,
  }),
  output: zNull(),
};
